import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Wrapper from './layout/Wrapper'

const Title = styled.h2`
  color: #dc1431;
  font-size: 18px;
  margin-bottom: 5px;
  font-weight: 400;
  margin-top:20px;

  ${breakpoint('desktop')`
    font-size: 24px;
  `}
`

const Subtitle = styled.p`
  font-size: 14px;
  margin: 0 0 20px;
  font-weight: 300;

  ${breakpoint('desktop')`
    font-size: 16px;
    margin: 0 0 40px;
  `}
`
const TitleSection = props => (
  <Wrapper>
    <Title>{props.title}</Title>
    <Subtitle>{props.subtitle}</Subtitle>
  </Wrapper>
)

export default TitleSection
